import { render, staticRenderFns } from "./SwitchElement.vue?vue&type=template&id=80b14350&scoped=true"
import script from "./SwitchElement.vue?vue&type=script&lang=js"
export * from "./SwitchElement.vue?vue&type=script&lang=js"
import style0 from "./SwitchElement.vue?vue&type=style&index=0&id=80b14350&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b14350",
  null
  
)

export default component.exports